import React from "react"
import classNames from "classnames"
import { DatePicker, DateRangePicker } from "rsuite"

const CommonDateFilter = ({
  isLoading,
  date,
  commonDateRange,
  setCommonDateRange,
  formattedToday,
  formatDate,
  commonDayType,
  setCommonDayType,
  t,
}) => {
  const onChangeChartPeriod = type => {
    if (typeof setCommonDayType === "function") {
      setCommonDayType(type)
    }
  }

  const handleOnDateChange = selectedDates => {
    if (!selectedDates) return
    const formattedDate = `${selectedDates.getFullYear()}-${(
      selectedDates.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${selectedDates.getDate().toString().padStart(2, "0")}`

    setCommonDateRange({
      start: `${formattedDate} 00:00`,
      end: `${formattedDate} 23:59`,
    })
  }

  const handleDateRangeChange = value => {
    if (!value?.[0] || !value?.[1]) return
    setCommonDateRange({
      start: formatDate(value[0]),
      end: formatDate(value[1]),
    })
  }

  const periodOptions = [
    { type: "day", label: t("Day"), id: "one_month" },
    { type: "week", label: t("Week") },
    { type: "month", label: t("Month") },
    { type: "custom", label: t("Custom") },
  ]

  const dayValue = new Date(date || commonDateRange?.start || formattedToday)
  const rangeValue = [
    new Date(commonDateRange?.start || formattedToday),
    new Date(commonDateRange?.end || formattedToday),
  ]

  return (
    <ul className="nav nav-pills dashboard-date-filter">
      {periodOptions.map(option => (
        <li className="nav-item" key={option.type}>
          <button
            type="button"
            className={classNames(
              { active: commonDayType === option.type },
              { "disabled-link": isLoading },
              "nav-link"
            )}
            onClick={() => !isLoading && onChangeChartPeriod(option.type)}
            id={option.id}
          >
            {option.label}
          </button>{" "}
        </li>
      ))}
      {/* SHOW */}

      <li style={{ maxWidth: 115, marginLeft: 5 }}>
        {commonDayType === "day" && (
          <DatePicker
            format="yyyy-MM-dd"
            value={dayValue}
            onChange={handleOnDateChange}
          />
        )}
      </li>

      <li style={{ maxWidth: 210, marginLeft: 10 }}>
        {commonDayType === "week" && (
          <DateRangePicker
            format="yyyy-MM-dd"
            value={rangeValue}
            hoverRange="week"
            ranges={[]}
            oneTap
            isoWeek
            onChange={handleDateRangeChange}
          />
        )}
      </li>
      <li style={{ maxWidth: 210, marginLeft: 10 }}>
        {commonDayType === "month" && (
          <DateRangePicker
            format="yyyy-MM-dd"
            value={rangeValue}
            hoverRange="month"
            ranges={[]}
            oneTap
            isoWeek
            onChange={handleDateRangeChange}
          />
        )}
      </li>

      <li style={{ maxWidth: 200, marginLeft: 5 }}>
        {commonDayType === "custom" && (
          <DateRangePicker
            format="yyyy-MM-dd HH:mm"
            value={rangeValue}
            ranges={[]}
            showTime
            showMeridian={false}
            onChange={handleDateRangeChange}
          />
        )}
      </li>
    </ul>
  )
}

export default CommonDateFilter
